import { useSelector } from "react-redux";
import currentUserState from "utils/currentUserState";

export function useCurrentUID() {
  return useSelector((state) => {
    const { currentUID } = currentUserState(state);
    return currentUID;
  });
}
